<template>
    <div class="evaluateCompany">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <!-- 主体 -->
        <div class="main">
            <div class="left">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>{{ documentTitle }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="content">
                    <div><img src="../../assets/img/index/title2.png" alt="" style="margin: 10px auto 0;"></div>
                    <div><img src="../../assets/img/index/division2.png" alt="" style="margin: 0 auto;width: 100%;"></div>
                    <div class="evaluate">
                        <div class="left">
                            <h4>评价信息</h4>
                            <div><i>信用等级: </i>{{detail.grade}}</div>
                            <div><i>证书编号: </i>{{detail.certificateNumber}}</div>
                            <div><i>认证时间: </i>{{detail.certificationDate}}</div>
                            <div><i>有效期至: </i>{{detail.effectiveDate}}</div>
                        </div>
                        <div class="right" v-if="detail.certificateUrl != '' && detail.certificateUrl != null">
                            <div>
                                <span v-if="isNtoImg" style="cursor: pointer;" @click="lookFile(detail.certificateUrl)">点击查看文件</span>
                                <el-image class="img" v-else :src="detail.certificateUrl" alt="" :preview-src-list="srcList">
                                </el-image>
                            </div>
                        </div>
                    </div>
                    <div><img src="../../assets/img/index/division2.png" alt="" style="margin: 10px auto 0;width: 100%;"></div>
                    <div class="cont">
                        <div class="left">
                            <h4>企业信息</h4>
                            <div><i>公司名称: </i>{{detail.name}}</div>
                            <div><i>统一社会信用代码: </i>{{detail.creditCode}}</div>
                            <div><i>法定代表人: </i>{{detail.legalName}}</div>
                            <div><i>成立日期: </i>{{detail.establishmentDate}}</div>
                            <div><i>登记机关: </i>{{detail.registrationAuthority}}</div>
                            <div><i>注册地址: </i>{{detail.address}}</div>
                            <div><i>经营范围: </i>{{detail.businessScope}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../../api/api'
import { decrypt } from '../../utils/decode'
import publicHeaders from '../../components/header.vue'
import foot from '../../components/foot.vue'
import {baseURL} from '../../api/network.js';
export default {
    name: 'evaluateCompany',
    components: {
        publicHeaders,
        foot
    },
    data() {
        return {
            documentTitle: '',
            baseUrl: baseURL,
            detail: {
                // companyName: '北京奇虎科技有限公司',
                // rank: 'AAA',
                // code: '911101026662879416',
                // date: '2023-09-07',
                // repDate: '2007年08月13日',
                // validity: '2024-09-06',
                // id: '911101026662879416',
                // repName: '周鸿浦',
                // repAdress: '北京市胡阳区酒仙桥路6号院2号楼1至19层104号内8层801',
                // manage: '技术开发、技术咨询、技术推广、网络技术服务：信息系统集成服务：网络安全集成服务：设计、制作、发布广告：销售通讯设备、电子产品、计算机、软件及埔助设备：教育咨询（不含中介及办学）：火车票销售代理：货物进出口.、代理进出口、技术进出口：经营电信业务：互联网信息服务：从事互联网文化活动。（市场主体依法自主选择经营项目，开展经营活动：经营电信业务、互联网信息服务、从事互联网文化活动以及依法须经批准的项目，经相关部门批准后依批准的内容开展经营活动：不得从事国家和本市产业政策禁止和限制类项目的经营活动。)',
                // authority: '北京市朝阳区市场监督管理局',
                // certificateUrl: require('../../assets/img/index/advertising1.png')
            },
            isNtoImg: false,
            srcList: []
        }
    },
    created() {
        window.scrollTo(0 ,0)
        this.documentTitle = this.$route.query.documentTitle
        document.title = this.$route.query.documentTitle
        this.srcList = []
        this.getCreditCompanyInfo()
    },
    mounted() {
    },
    methods: {
        // 获取详情
        getCreditCompanyInfo() {
            let _this = this
            let params = {
                id: this.$route.query.id
            }
            api.getCreditCompanyInfo(params).then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    console.log(data.data.certificateUrl);
                    var imgRegExp = /\.(jpg|jpeg|png|gif|bmp)$/i;
                    if (data.data.certificateUrl == '' || data.data.certificateUrl == null) {
                        data.data.certificateUrl = ''
                    } else {
                        if (imgRegExp.test(data.data.certificateUrl)) {
                            data.data.certificateUrl = baseURL + data.data.certificateUrl
                            console.log(data.data.certificateUrl);
                            this.srcList.push(data.data.certificateUrl)
                        } else {
                            this.isNtoImg = true
                            data.data.certificateUrl = baseURL + data.data.certificateUrl
                        }
                    }
                    
                    _this.detail = data.data
                } else {
                    
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 点击查看文件
        lookFile(file) {
            window.open(file, '_blank');
        },

        // 图片预览
        lookImg() {

        }
    }
}
</script>

<style lang="less" scoped>
.evaluateCompany {
    position: relative;
    padding-bottom: 140px;
    .main {
        width: 70%;
        padding: 15px 50px;
        margin: 0 auto;
        @media only screen and (min-width: 769px) {
            min-width: 1152px;
        }
        .left {
            margin-right: 5px;
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
            .content {
                min-height: 800px;
                border: 1px solid #D9D9D9;
                margin-top: 10px;
                padding: 20px 50px 50px;
                background: url('../../assets/img/index/watermark.png') no-repeat;
                background-position-x: center;
                .evaluate {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    /* padding: 0 300px; */
                    .left {
                        font-size: 18px;
                        color: #333;
                        h4 {
                            font-size: 22px;
                            font-weight: 700;
                            margin-bottom: 15px;
                            color: #111;
                        }
                        i {
                            color: #1A68E8;
                            padding-right: 2px;
                        }
                    }
                    .right {
                        border: 1px solid #D9D9D9;
                        background-color: #fff;
                        padding: 10px;
                        /* cursor: pointer; */
                        span {
                            border: 1px solid #1A68E8;
                            color: #1A68E8;
                            padding: 5px 9px;
                        }
                        .img {
                            width: 300px;
                            height: 200px;
                            object-fit: contain;
                        }
                    }
                }
                .cont {
                    display: flex;
                    justify-content: left;
                    /* padding: 0 300px; */
                    .left {
                        font-size: 18px;
                        color: #333;
                        h4 {
                            font-size: 22px;
                            font-weight: 700;
                            margin-bottom: 15px;
                            color: #111;
                        }
                        i {
                            color: #1A68E8;
                            padding-right: 2px;
                        }
                    }
                }
            }
        }
    }
}
</style>